module.exports = __webpack_public_path__ + "media/icons/silverware-b3f72108.svg";